import { FEATURE_CONTROL_GLOBAL_WINDOW_NAMESPACE } from '../../constants/global';
import buildHubspotUrl from '../../utils/buildHubspotUrl';
import reportErrorToLogFetch from 'ui-forms-embed-components-modules/internal/reportEvent/reportErrorToLogFetch';
import { FEATURE_CONTROL_FETCH_ERROR } from 'ui-forms-embed-components-reporting/reporting/internal/constants';
import getFetchErrorCause from 'ui-forms-embed-components-reporting/reporting/internal/getFetchErrorCause';
export const fetchFeatureControl = (hublet, isQa, portalId, formId, _window = window) => {
  if (!_window) return Promise.resolve(null);
  if (_window[FEATURE_CONTROL_GLOBAL_WINDOW_NAMESPACE]) {
    return _window[FEATURE_CONTROL_GLOBAL_WINDOW_NAMESPACE];
  }
  if (!portalId) {
    return Promise.resolve(null);
  }
  const url = buildHubspotUrl({
    hublet,
    isQa,
    subDomainPrefix: 'forms',
    domainOverride: 'hsforms',
    pathname: 'embed/v4/feature-control/{{portalId}}',
    pathValues: {
      portalId
    }
  });
  const promise = fetch(url).then(res => res.json().then(body => ({
    body,
    response: res
  }))).catch(async error => {
    const cause = await getFetchErrorCause(url, error);
    reportErrorToLogFetch({
      formId,
      portalId,
      hublet,
      isQa,
      key: FEATURE_CONTROL_FETCH_ERROR,
      error,
      data: {
        requestUrl: url,
        cause
      }
    });
    return null;
  });
  _window[FEATURE_CONTROL_GLOBAL_WINDOW_NAMESPACE] = promise;
  return promise;
};